// src/api/index.js
import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/api', // 统一的后端接口前缀
  timeout: 10000
})

// 请求拦截器（可加 token、loading 等）
service.interceptors.request.use(
  config => {
    // config.headers['Authorization'] = 'Bearer ' + token
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器（可统一处理错误、登录失效等）
service.interceptors.response.use(
  response => response.data,
  error => {
    // 统一错误提示
    // Message.error(error.response?.data?.message || '请求出错')
    return Promise.reject(error)
  }
)

export default service